import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

export function useShareCtaPlacementEnabled(): boolean {
	const {
		data: {
			featureConfigs: { petitionDetailsShareCtaPlacement },
		},
	} = usePetitionDetailsPageData();
	const isMobile = useIsMobile();

	// The former experiment gated on `isEnabledByFC(experiment) && isMobile(utilityContext)` — the
	// FC alone isn't enough, since the mobile action-button tree it renders into is only CSS-hidden
	// (`block md:hidden`) on desktop, not gated by device type. Without this, a desktop UA at a
	// narrow viewport would render the affordance even though it's never a real native-share target.
	return Boolean(petitionDetailsShareCtaPlacement?.enabled) && isMobile;
}
